var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.showComponent)?_c('div',{attrs:{"id":"powered-by-eventfinity-container"}},[_c('span',{staticClass:"powered-by-text"},[_vm._v("Powered by")]),_vm._v(" "),_c('div',{staticClass:"powered-by-eventfinity-logo",attrs:{"aria-label":"Eventfinity Logo"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }